// stub out getProductItemType
// TODO: Fix this
const getProductItemType = () => 'Candidate';
const getProductItemI18nKey = () => 'candidate';
import { channelTypes } from 'appConstants';

export const metricsTypes = {
  CAMPAIGN_METRICS: 'campaign',
  CUSTOMER_METRICS: 'customer',
};

const messagesUrl = 'reports/messages';
export const thirty = 30;

export const reportingTypes = {
  ALL_MESSAGES_REPORT: {
    name: 'Messages',
    i18nKey: 'messages',
    order: 1,
    value: { url: messagesUrl, channel: channelTypes.ALL },
  },
  SMS_REPORT: {
    name: 'Messages (SMS)',
    i18nKey: 'messages_sms',
    order: 2,
    value: { url: messagesUrl, channel: channelTypes.SMS },
  },
  WHATSAPP_REPORT: {
    name: 'Messages (WhatsApp)',
    i18nKey: 'messages_whatsapp',
    order: 3,
    value: { url: messagesUrl, channel: channelTypes.WHATS_APP },
  },
  FB_MESSENGER_REPORT: {
    name: 'Messages (Facebook)',
    i18nKey: 'messages_facebook',
    order: 4,
    value: { url: messagesUrl, channel: channelTypes.FACEBOOK_MESSENGER },
  },
  WECHAT_REPORT: {
    name: 'Messages (WeChat)',
    i18nKey: 'messages_wechat',
    order: 5,
    value: { url: messagesUrl, channel: channelTypes.WECHAT },
  },
  SCHEDULED_MESSAGES_REPORT: {
    name: 'Scheduled Messages',
    i18nKey: 'scheduled_messages',
    order: 6,
    value: { url: 'reports/messages/scheduled' },
  },
  CAMPAIGNS_REPORT: {
    name: 'Campaigns',
    i18nKey: 'campaigns',
    order: 7,
    value: { url: 'reports/campaign_metrics/summary' },
  },
  BASIC_USER_STATS_REPORT: {
    name: 'Basic User Stats',
    i18nKey: 'basic_user_stats',
    order: 8,
    value: { url: 'reports/user_metrics/summary' },
  },
  FULL_STATS_REPORT: {
    name: 'Full Stats',
    i18nKey: 'full_stats',
    order: 9,
    value: { url: 'reports/stats/all' },
  },
  USER_SUMMARY_STATS_REPORT: {
    name: 'User Summary Stats',
    i18nKey: 'user_summary_stats',
    order: 10,
    value: { url: 'reports/userstats/summary' },
  },
  CANDIDATES_REPORT: {
    name: `${getProductItemType()}s`,
    i18nKey: `${getProductItemI18nKey()}s`,
    order: 11,
    value: { url: 'reports/candidates' },
  },
  DO_NOT_TEXT_REPORT: {
    name: 'Do Not Text',
    i18nKey: 'do_not_text',
    order: 12,
    value: { url: 'reports/do_not_text' },
  },
  ARI_ANALYTICS_REPORT: {
    name: 'Digital Assistant Analytics',
    i18nKey: 'digital_assistant_analytics',
    order: 13,
    reportGenerationDisabled: true,
    value: { url: 'reports/ari_analytics' },
  },
  USERS_REPORT: {
    name: 'Users Report',
    i18nKey: 'users_report',
    order: 14,
    value: { url: 'reports/users' },
  },
  ANNUAL_REPORT: {
    name: 'Annual Report',
    i18nKey: 'annual_report',
    order: 15,
    reportGenerationDisabled: true,
    value: { url: 'reports/annual' },
  },
  CREDIT_ACTIVITY_REPORT: {
    name: 'Credit Activity',
    i18nKey: 'credit_activity',
    order: 16,
    value: { url: 'reports/report_credit_activity' },
  },
  USER_WORKING_HOURS: {
    name: 'User Working Hours',
    i18nKey: 'user_working_hours',
    order: 17,
    value: { url: 'reports/usersWorkingHours' },
  },
  TEAM_AUDIT_LOG_REPORT: {
    name: 'Team Audit Log Report',
    i18nKey: 'team_audit_log_report',
    order: 18,
    value: { url: 'reports/teamAuditLogReport' },
  },
};

export const timeframes = {
  LAST_30_DAYS: { name: 'Last 30 Days', i18nKey: 'last_30_days', value: 'Last 30 Days' },
  LAST_90_DAYS: { name: 'Last 90 Days', i18nKey: 'last_90_days', value: 'Last 90 Days' },
  LAST_60_DAYS: { name: 'Last 60 Days', i18nKey: 'last_60_days', value: 'Last 60 Days' },
  ALL_TIME: { name: 'All Time', i18nKey: 'all_time', value: 'All' },
  DATE_RANGE: { name: 'Date Range', i18nKey: 'date_range', value: 'Custom' },
};

export const normalTimeframeOptions = [
  timeframes.LAST_30_DAYS,
  timeframes.LAST_90_DAYS,
  timeframes.ALL_TIME,
  timeframes.DATE_RANGE,
];

export const teamAuditLogTFOptions = [
  timeframes.LAST_30_DAYS,
  timeframes.LAST_90_DAYS,
  timeframes.DATE_RANGE,
];

export const yearlyTimeframeOptions = [
  { name: '2017', i18nKey: '2017', value: '2017' },
  { name: '2018', i18nKey: '2018', value: '2018' },
  { name: '2019', i18nKey: '2019', value: '2019' },
  { name: '2020', i18nKey: '2020', value: '2020' },
  { name: '2021', i18nKey: '2021', value: '2021' },
];

export const allTimeframeOptions = normalTimeframeOptions.concat(yearlyTimeframeOptions);
